import React, { PureComponent } from 'react';

import PropTypes from 'prop-types';

import TabNavigation from './_internal/TabNavigation';
import MainBanner from './_internal/MainBanner';
import StickyHeader from './_internal/StickyHeader';
import { PRICING_PROP_TYPES } from '../constants/componentPropTypes';
import { ASSORTMENT_TAX_PROP_TYPES } from '../constants/pricingPropTypes';

export default class MainHeader extends PureComponent {
    static propTypes = {
        ...PRICING_PROP_TYPES,
        currentIndex: PropTypes.number.isRequired,
        tabs: PropTypes.arrayOf(
            PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        ).isRequired,
        tabActions: PropTypes.arrayOf(PropTypes.func),
        tabPaths: PropTypes.arrayOf(PropTypes.string),
        taxLabel: ASSORTMENT_TAX_PROP_TYPES,
    };

    state = {
        node: null,
    };

    _setRef(node) {
        this.setState({ node });
    }

    render() {
        const {
            currentIndex,
            imagePath,
            bgImgHeight,
            illustration,
            tabs,
            tabActions,
            tabPaths,
            primaryCTA,
            heading,
            hidePricing,
            description,
            secondaryHeading,
            perPaidTicketText,
            price,
            priceDescription,
            onClick,
            onStickyClick,
            CTAStyle,
            dataAutomation,
            taxLabel,
            pricingCalloutAction,
            pricingCalloutText,
            pricingCalloutDescriptionPrimary,
            pricingCalloutDescriptionSecondary,
        } = this.props;
        const { node } = this.state;

        return (
            <div ref={this._setRef.bind(this)} data-automation={dataAutomation}>
                <TabNavigation
                    currentIndex={currentIndex}
                    tabs={tabs}
                    tabActions={tabActions}
                    tabPaths={tabPaths}
                    alternateAlignment={true}
                />
                <StickyHeader parentNode={node}>
                    <TabNavigation
                        currentIndex={currentIndex}
                        tabs={tabs}
                        tabActions={tabActions}
                        tabPaths={tabPaths}
                        onClick={onStickyClick}
                        CTA={primaryCTA}
                        CTAStyle={CTAStyle}
                        alternateAlignment={true}
                    />
                </StickyHeader>
                <MainBanner
                    illustration={illustration}
                    imagePath={imagePath}
                    bgImgHeight={bgImgHeight}
                    heading={heading}
                    secondaryHeading={secondaryHeading}
                    description={description}
                    perPaidTicketText={perPaidTicketText}
                    price={price}
                    taxLabel={taxLabel}
                    priceDescription={priceDescription}
                    CTA={primaryCTA}
                    CTAStyle={CTAStyle}
                    onClick={onClick}
                    hidePricing={hidePricing}
                    pricingCalloutAction={pricingCalloutAction}
                    pricingCalloutText={pricingCalloutText}
                    pricingCalloutDescriptionPrimary={
                        pricingCalloutDescriptionPrimary
                    }
                    pricingCalloutDescriptionSecondary={
                        pricingCalloutDescriptionSecondary
                    }
                />
            </div>
        );
    }
}
